(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index__hover-infographic"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
    if(window.innerWidth <= 798) {
      document.querySelectorAll('.feature-box').forEach(box => {
        box.addEventListener('click', () => {
          box.classList.toggle('tapped');
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty-table"] && !Shopify.designMode) return;
  try {
    
/* Any necessary JavaScript can go here */

  } catch(e) { console.error(e); }
})();
})();
